module.exports = __webpack_public_path__ + "static/img/9.9231a6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/9.png
// module id = 2m0J
// module chunks = 0